export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DIVISIONS = [
  {
    slug: "luxury-car-rentals",
    index: "01",
    name: "Luxury Car Rentals",
    tag: "Automotive",
    short: "An elite fleet of exotic and luxury vehicles for those who move differently.",
    image: "https://images.pexels.com/photos/94272/sports-car-pkw-auto-vehicle-94272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    hero: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: "Arrival is a statement. Our curated collection of exotic and premium automobiles delivers unrivaled performance and presence for weddings, corporate travel, and unforgettable escapes.",
    externalUrl: "https://iceexotics.com/",
    externalLabel: "Visit ICE Exotics",
    features: [
      "Hand-selected exotic & luxury fleet",
      "White-glove delivery & concierge",
      "Chauffeur and self-drive options",
      "Corporate & event partnerships",
    ],
  },
  {
    slug: "events-entertainment",
    index: "02",
    name: "Events & Entertainment",
    tag: "Experiences",
    short: "Motivational speaking, red-carpet appearances, and hit-show productions with Jewell.",
    image: "/event-jpns-flyer.jpg",
    hero: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: "From intimate soirées to headline productions, we design and stage experiences that linger long after the lights dim — every detail choreographed, every moment intentional.",
    features: [
      "Full-scale event design & production",
      "Talent & entertainment booking",
      "Luxury galas & brand activations",
      "Bespoke concept development",
    ],
  },
  {
    slug: "self-care",
    index: "03",
    name: "Self-Care",
    tag: "Wellness",
    short: "Jewells Herbal Magic Blend — a handcrafted herbal tea to nourish, heal & restore.",
    image: "/jewells-herbal-blend.jpg",
    hero: "/jewells-herbal-blend.jpg",
    intro: "Wellbeing is the ultimate luxury. Our self-care line — led by the Jewells Herbal Magic Blend — pairs ancient botanicals with modern intention to restore body, mind, and spirit.",
    features: [
      "Handcrafted small-batch herbal tea",
      "16 intentional botanicals",
      "Caffeine free & all natural",
      "Ethically sourced, sustainably packaged",
    ],
  },
  {
    slug: "restaurant-chains",
    index: "04",
    name: "Restaurant Chains",
    tag: "Franchise",
    short: "A turnkey franchise model — own a signature dining concept backed by the enterprise.",
    image: "https://images.unsplash.com/photo-1740125492753-28394dac8165?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    hero: "https://images.unsplash.com/photo-1677404216898-cc472fe9c31e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: "Great food meets proven systems. Our restaurant concepts are engineered to scale — giving entrepreneurs a turnkey franchise with brand power, training, and support at every step. Own a destination, backed by the enterprise.",
    featuresTitle: "Why Franchise With Us",
    features: [
      "Turnkey, proven business model",
      "Brand, marketing & supply-chain support",
      "Comprehensive operator training & onboarding",
      "Prime, protected multi-unit territories",
    ],
    franchiseStats: [
      { v: "12+", l: "Locations & Growing" },
      { v: "4–6 mo", l: "Avg. Time to Open" },
      { v: "360°", l: "Franchisee Support" },
    ],
    franchiseSteps: [
      { t: "Apply", d: "Submit a franchise inquiry and tell us about your market and goals." },
      { t: "Discovery", d: "Meet our team; review the model, unit economics & available territories." },
      { t: "Sign & Train", d: "Secure your territory and complete our immersive operator training." },
      { t: "Open & Grow", d: "Launch with full build-out, marketing & ongoing operational support." },
    ],
    ctaTitle: "Own a franchise",
    ctaText: "Request our franchise information kit and discover the territories available in your region.",
    ctaButton: "Request Franchise Info",
  },
  {
    slug: "philanthropy",
    index: "05",
    name: "Philanthropy",
    tag: "Impact",
    short: "The heart of the enterprise — lifting communities, women, and children worldwide.",
    image: "/phil-kids.jpg",
    hero: "/phil-family.jpg",
    intro: "Legacy is measured in lives changed. Through our philanthropic arm we channel resources into orphanages, women's empowerment, and community programs — turning success into shared prosperity.",
    features: [
      "Orphanage support & sponsorship",
      "Women's empowerment initiatives",
      "Global community outreach",
      "Charity partner network",
    ],
    galleryOverline: "Athi River, Kenya",
    galleryTitle: "Moments from the field.",
    gallery: [
      { src: "/phil-heart.jpg", place: "Athi River, Kenya", caption: "Hands together, hearts as one." },
    ],
  },
];

export const ROLES = [
  { title: "Director of Partnerships", type: "Full-time", location: "Remote / HQ", dept: "Corporate" },
  { title: "Luxury Fleet Manager", type: "Full-time", location: "On-site", dept: "Automotive" },
  { title: "Event Production Lead", type: "Full-time", location: "Hybrid", dept: "Events" },
  { title: "Spa & Wellness Director", type: "Full-time", location: "On-site", dept: "Self-Care" },
  { title: "Executive Chef", type: "Full-time", location: "On-site", dept: "Culinary" },
  { title: "Community Impact Coordinator", type: "Contract", location: "Remote", dept: "Philanthropy" },
];

export const SOCIALS = ["Instagram", "LinkedIn", "Facebook", "X"];
